<template>
  <tr
    :class="{
      'bg-tbl-pink': selectedCd === deliveryData.delivery_cd,
      'bg-tbl-green': deliveryData.new_fg == 1,
      'bg-tbl-light': deliveryData.modify_fg == 9
    }"
  >
    <td v-bs-tooltip.top="deliveryData.dlcompany_na">
      <template v-if="deliveryData.modify_fg">
        <span
          v-if="deliveryData.modify_fg == 1"
          class="badge badge-primary mb-1"
          >修正中</span
        >
        <span
          v-if="deliveryData.modify_fg == 9"
          class="badge badge-secondary mb-1"
          >削除中</span
        >
        <br />
      </template>
      {{ deliveryData.dlcompany_na }}
    </td>
    <td v-bs-tooltip.top="deliveryData.dlcompanysub_na">
      {{ deliveryData.dlcompanysub_na }}
    </td>
    <td v-bs-tooltip.top="deliveryData.dladdress_na">
      {{ deliveryData.dladdress_na }}
    </td>
    <td v-bs-tooltip.top="deliveryData.dltel_no">
      {{ deliveryData.dltel_no }}
    </td>
    <td class="text-center">
      <button
        class="btn btn-sm btn-request"
        @click="selectDeliveryDataHandler(deliveryData)"
        :disabled="deliveryData.modify_fg == 9"
        v-if="!deliveryData.is_added"
      >
        選 択
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    selectedCd: { type: String, required: true },
    deliveryData: { type: Object, required: true }
  },
  methods: {
    selectDeliveryDataHandler(deliveryData) {
      this.$emit("select", deliveryData);
    }
  }
};
</script>
